module.exports = "<group-list>Loading...</group-list>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/groups/group.component.html
// module id = 2132
// module chunks = 0